import { RoleValueType } from '@klickdata/core/user';

export interface NotificationSetting {
    type?: string;
    enabled?: boolean;
}

export interface NotificationTypes {
    [key: string]: {
        role_values: RoleValueType[];
        label: string;
        description: string;
        children?: {
            [key: string]: {
                role_values: RoleValueType[];
                label: string;
                description: string;
            };
        };
    };
}

export const NotificationTypes: NotificationTypes = {
    new_message: {
        role_values: ['user', 'customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        label: $localize`New message`,
        description: $localize`Receive notifications for new messages`,
    },
    enrollment: {
        role_values: ['user', 'customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        label: $localize`Enrollment`,
        description: $localize`Receive notifications for enrollment updates`,
    },
    signoff: {
        label: $localize`Signoff`,
        description: $localize`Receive notifications for signoff events`,
        role_values: ['customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        children: {
            signoff_passed: {
                role_values: ['customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
                label: $localize`Signoff Passed`,
                description: $localize`Receive notifications for signoff events`,
            },
            signoff_failed: {
                role_values: ['customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
                label: $localize`Signoff Failed`,
                description: $localize`Receive notifications for signoff events`,
            },
        },
    },
    publish: {
        role_values: ['customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        label: $localize`Publish`,
        description: $localize`Receive notifications for new publishes`,
    },
    recommend: {
        role_values: ['user', 'customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        label: $localize`Recommendation`,
        description: $localize`Notify me with recommendation`,
    },
    newsletter: {
        role_values: ['user', 'customeradmin', 'divisionadmin', 'groupadmin', 'superadmin'],
        label: $localize`Newsletter`,
        description: $localize`I want to get KLMS monthly newsletter`,
    },
};

export type NotificationTypeKey = keyof typeof NotificationTypes;
